
import React, { useRef, useState } from 'react';
import '../css/Avisos.css';

// ============================================
// IMÁGENES
// ============================================

import uniforme from '../img/Avisos/uniformenz.jpg';
//import Aviso2 from '../img/Avisos/Comunicado-01.jpg';
import Aviso3 from '../img/Avisos/Comunicado trabajos techumbres.jpg';
import Aviso4 from '../img/Avisos/admision2027.jpg';
import Aviso5 from '../img/Avisos/Reunion dia miercoles 09 de septiembre 2026.png';
import Aviso06 from '../img/Avisos/jeansday.jpeg';
import Aviso07 from '../img/Avisos/aviso01.mp4';


// ============================================
// COMPONENTE
// ============================================

const EventsComponent = () => {

    const scrollRef = useRef(null);


    // ============================================
    // VISOR
    // ============================================

    const [selectedEvent, setSelectedEvent] = useState(null);


    // ============================================
    // DATOS DE LOS AVISOS
    //
    // TIPOS DISPONIBLES:
    //
    // image     = imagen
    // pdf       = documento PDF
    // video     = video local
    // youtube   = video de YouTube
    // instagram = publicación de Instagram
    // link      = enlace externo
    //
    // ============================================

    const eventsData = [

        // ========================================
        // AVISO ACTUAL
        // ========================================

        
        {
            id: 6,
            date: 'jeans Day',
            title: 'Miercoles 09 de Septiembre 2026',
            description: '',
            imageUrl: Aviso06,
            type: 'image',
        },

          {
            id: 7,
            date: 'Entrevista Banda de Guerra',
            title: 'Viernes 04 de Septiembre 2026',
            description: '',
            imageUrl: Aviso07,
            type: 'video',
        },
        
        
        {
            id: 5,
            date: 'Reunión de Apoderados',
            title: 'Miercoles 09 de Septiembre 2026',
            description: '',
            imageUrl: Aviso5,
            type: 'image',
        },



 // ========================================
        // EJEMPLO YOUTUBE
        //
        // NO necesitas descargar la miniatura.
        //
        // El sistema la obtiene automáticamente.
        //
        // ========================================

        
         /*{
            id: 8,
            date: 'Agosto 2026',
            title: 'Aniversario N° 35 Municipalidad Independencia',
            description: 'Desfile Banda de Guerra',
            type: 'youtube',
            link: 'https://www.youtube.com/watch?v=wejpuYYMcEc',
         },*/



        // ========================================
        // ADMISION
        // ========================================

        {
            id: 4,
            date: 'Admisión Escolar 2027',
            title: '',
            description: '',
            imageUrl: Aviso4,
            type: 'image',
        },


        // ========================================
        // COMUNICADO
        // ========================================

        {
            id: 3,
            date: 'Comunicado Importante',
            title: 'Viernes 15 de Mayo 2026',
            description: '',
            imageUrl: Aviso3,
            type: 'image',
        },


        // ========================================
        // EJEMPLO DE PDF
        //
        // Para usarlo posteriormente:
        //
        // import documento from '../img/Avisos/documento.pdf';
        //
        // {
        //     id: 10,
        //     date: 'Septiembre 2026',
        //     title: 'Documento importante',
        //     description: '',
        //     imageUrl: documento,
        //     type: 'pdf',
        // },
        //
        // ========================================


       
        


        // ========================================
        // EJEMPLO INSTAGRAM
        //
        // Para Instagram recomendamos colocar
        // una imagen de portada propia.
        //
        // ========================================

        /*
        {
            id: 9,
            date: 'Septiembre 2026',
            title: 'Nueva publicación',
            description: 'Revisa nuestra publicación en Instagram.',
            type: 'instagram',
            link: 'https://www.instagram.com/p/XXXXXXXXXXX/',
            preview: imagenInstagram,
        },
        */


        // ========================================
        // UNIFORME ESCOLAR
        // ========================================

        {
            id: 0,
            date: 'Uniforme Escolar',
            title: 'Escuela Nueva Zelandia 2025',
            description: '',
            imageUrl: uniforme,
            type: 'image',
        },

    ];


    // ============================================
    // SCROLL IZQUIERDA
    // ============================================

    const scrollLeft = () => {

        scrollRef.current.scrollBy({
            left: -320,
            behavior: 'smooth',
        });

    };


    // ============================================
    // SCROLL DERECHA
    // ============================================

    const scrollRight = () => {

        scrollRef.current.scrollBy({
            left: 320,
            behavior: 'smooth',
        });

    };


    // ============================================
    // ABRIR VISOR
    // ============================================

    const openViewer = (event) => {

        setSelectedEvent(event);

    };


    // ============================================
    // CERRAR VISOR
    // ============================================

    const closeViewer = () => {

        setSelectedEvent(null);

    };


    // ============================================
    // OBTENER ID DE YOUTUBE
    // ============================================

    const getYouTubeId = (url) => {

        if (!url) {
            return null;
        }


        const patterns = [

            /youtu\.be\/([^?&]+)/,

            /youtube\.com\/watch\?v=([^?&]+)/,

            /youtube\.com\/embed\/([^?&]+)/,

            /youtube\.com\/shorts\/([^?&]+)/,

        ];


        for (const pattern of patterns) {

            const match = url.match(pattern);

            if (match) {

                return match[1];

            }

        }


        return null;

    };


    // ============================================
    // MINIATURA DE YOUTUBE
    // ============================================

    const getYouTubeThumbnail = (url) => {

        const videoId = getYouTubeId(url);


        if (!videoId) {

            return null;

        }


        return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;

    };


    // ============================================
    // RENDER DE LA TARJETA
    // ============================================

    const renderMedia = (event) => {


        // ========================================
        // YOUTUBE
        // ========================================

        if (event.type === 'youtube') {

            const thumbnail =
                getYouTubeThumbnail(event.link);


            return (

                <div
                    className="esc-social-preview"
                    onClick={() => openViewer(event)}
                >

                    {thumbnail ? (

                        <img
                            src={thumbnail}
                            alt={event.title}
                            className="esc-social-imagen"
                        />

                    ) : (

                        <div className="esc-social-placeholder">

                            ▶️

                            <span>
                                Video de YouTube
                            </span>

                        </div>

                    )}


                    <div className="esc-youtube-play">

                        ▶

                    </div>

                </div>

            );

        }


        // ========================================
        // INSTAGRAM
        // ========================================

        if (event.type === 'instagram') {

            return (

                <div
                    className="esc-social-preview"
                    onClick={() => openViewer(event)}
                >

                    {event.preview ? (

                        <img
                            src={event.preview}
                            alt={event.title}
                            className="esc-social-imagen"
                        />

                    ) : (

                        <div className="esc-social-placeholder">

                            📸

                            <span>
                                Ver publicación en Instagram
                            </span>

                        </div>

                    )}

                </div>

            );

        }


        // ========================================
        // ENLACE
        // ========================================

        if (event.type === 'link') {

            return (

                <div
                    className="esc-social-preview"
                    onClick={() => openViewer(event)}
                >

                    <div className="esc-social-placeholder">

                        🔗

                        <span>
                            Ver contenido
                        </span>

                    </div>

                </div>

            );

        }


        // ========================================
        // IMAGEN
        // ========================================

        if (event.type === 'image') {

            return (

                <img
                    src={event.imageUrl}
                    alt={event.title || event.date}
                    className="esc-aviso-imagen"
                    onClick={() => openViewer(event)}
                />

            );

        }


        // ========================================
        // PDF
        // ========================================

        if (event.type === 'pdf') {

            return (

                <div
                    className="esc-pdf-container"
                    onClick={() => openViewer(event)}
                >

                    <iframe
                        src={event.imageUrl}
                        title="Vista previa PDF"
                        className="esc-pdf-preview"
                    />

                    <div className="esc-pdf-overlay">

                        📄 Ver documento

                    </div>

                </div>

            );

        }


        // ========================================
        // VIDEO LOCAL
        // ========================================

        if (event.type === 'video') {

            return (

                <video
                    src={event.imageUrl}
                    muted
                    playsInline
                    className="esc-aviso-video"
                    onClick={() => openViewer(event)}
                />

            );

        }


        return null;

    };


    // ============================================
    // VISOR
    // ============================================

    const renderViewer = () => {

        if (!selectedEvent) {

            return null;

        }


        const event = selectedEvent;


        // ========================================
        // YOUTUBE
        // ========================================

        if (event.type === 'youtube') {

            const videoId =
                getYouTubeId(event.link);


            return (

                <div
                    className="esc-aviso-viewer"
                    onClick={closeViewer}
                >

                    <div
                        className="esc-aviso-viewer-contenido esc-youtube-contenido"
                        onClick={(e) => e.stopPropagation()}
                    >


                        <button
                            className="esc-aviso-viewer-cerrar"
                            onClick={closeViewer}
                            aria-label="Cerrar"
                        >

                            ✕

                        </button>


                        {videoId ? (

                            <iframe
                                src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
                                title={event.title}
                                className="esc-youtube-player"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowFullScreen
                            />

                        ) : (

                            <div className="esc-error-contenido">

                                No se pudo cargar el video de YouTube.

                            </div>

                        )}

                    </div>

                </div>

            );

        }


        // ========================================
        // INSTAGRAM
        // ========================================

        if (event.type === 'instagram') {

            return (

                <div
                    className="esc-aviso-viewer"
                    onClick={closeViewer}
                >

                    <div
                        className="esc-aviso-viewer-contenido esc-instagram-contenido"
                        onClick={(e) => e.stopPropagation()}
                    >


                        <button
                            className="esc-aviso-viewer-cerrar"
                            onClick={closeViewer}
                            aria-label="Cerrar"
                        >

                            ✕

                        </button>


                        <div className="esc-instagram-card">

                            <div className="esc-instagram-icon">

                                📸

                            </div>


                            <h3>

                                {event.title || 'Instagram'}

                            </h3>


                            <p>

                                Para ver esta publicación,
                                haz clic en el botón.

                            </p>


                            <a
                                href={event.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="esc-instagram-boton"
                            >

                                Ver publicación en Instagram

                            </a>

                        </div>


                    </div>

                </div>

            );

        }


        // ========================================
        // ENLACE
        // ========================================

        if (event.type === 'link') {

            return (

                <div
                    className="esc-aviso-viewer"
                    onClick={closeViewer}
                >

                    <div
                        className="esc-aviso-viewer-contenido"
                        onClick={(e) => e.stopPropagation()}
                    >

                        <button
                            className="esc-aviso-viewer-cerrar"
                            onClick={closeViewer}
                            aria-label="Cerrar"
                        >

                            ✕

                        </button>


                        <div className="esc-instagram-card">

                            <div className="esc-instagram-icon">

                                🔗

                            </div>


                            <h3>

                                {event.title || 'Contenido'}

                            </h3>


                            <a
                                href={event.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="esc-instagram-boton"
                            >

                                Abrir contenido

                            </a>

                        </div>

                    </div>

                </div>

            );

        }


        // ========================================
        // PDF
        // ========================================

        if (event.type === 'pdf') {

            return (

                <div
                    className="esc-aviso-viewer"
                    onClick={closeViewer}
                >

                    <div
                        className="esc-aviso-viewer-contenido"
                        onClick={(e) => e.stopPropagation()}
                    >


                        <button
                            className="esc-aviso-viewer-cerrar"
                            onClick={closeViewer}
                            aria-label="Cerrar"
                        >

                            ✕

                        </button>


                        <iframe
                            src={event.imageUrl}
                            title={event.title}
                            className="esc-aviso-viewer-pdf"
                        />

                    </div>

                </div>

            );

        }


        // ========================================
        // VIDEO LOCAL
        // ========================================

        if (event.type === 'video') {

            return (

                <div
                    className="esc-aviso-viewer"
                    onClick={closeViewer}
                >

                    <div
                        className="esc-aviso-viewer-contenido"
                        onClick={(e) => e.stopPropagation()}
                    >


                        <button
                            className="esc-aviso-viewer-cerrar"
                            onClick={closeViewer}
                            aria-label="Cerrar"
                        >

                            ✕

                        </button>


                        <video
                            src={event.imageUrl}
                            controls
                            autoPlay
                            playsInline
                            className="esc-aviso-viewer-video"
                        />

                    </div>

                </div>

            );

        }


        // ========================================
        // IMAGEN
        // ========================================

        return (

            <div
                className="esc-aviso-viewer"
                onClick={closeViewer}
            >

                <div
                    className="esc-aviso-viewer-contenido"
                    onClick={(e) => e.stopPropagation()}
                >


                    <button
                        className="esc-aviso-viewer-cerrar"
                        onClick={closeViewer}
                        aria-label="Cerrar"
                    >

                        ✕

                    </button>


                    <img
                        src={event.imageUrl}
                        alt={event.title || event.date}
                        className="esc-aviso-viewer-imagen"
                    />

                </div>

            </div>

        );

    };


    // ============================================
    // RETURN
    // ============================================

    return (

        <section
            id="events-component"
            className="esc-avisos-container"
        >


            {/* ==================================
                ENCABEZADO
            ================================== */}

            <div className="esc-avisos-header">

                <div className="esc-linea-azul"></div>


                <h2>
                    INFORMACIONES IMPORTANTES
                </h2>


                <div className="esc-linea-roja"></div>


                <p>
                    Comunicados, reuniones y noticias relevantes
                    de nuestra comunidad educativa.
                </p>

            </div>


            {/* ==================================
                CARRUSEL
            ================================== */}

            <div className="esc-avisos-carousel">


                <button
                    className="esc-avisos-arrow"
                    onClick={scrollLeft}
                    aria-label="Ver avisos anteriores"
                >

                    ❮

                </button>


                <div
                    className="esc-avisos-lista"
                    ref={scrollRef}
                >


                    {eventsData.map((event) => (

                        <article
                            key={event.id}
                            className="esc-aviso-card"
                        >


                            <div className="esc-aviso-fecha">

                                {event.date}

                            </div>


                            <div className="esc-aviso-contenido">


                                {event.title && (

                                    <h3>

                                        {event.title}

                                    </h3>

                                )}


                                {event.description && (

                                    <p>

                                        {event.description}

                                    </p>

                                )}


                                {renderMedia(event)}


                            </div>


                        </article>

                    ))}


                </div>


                <button
                    className="esc-avisos-arrow"
                    onClick={scrollRight}
                    aria-label="Ver avisos siguientes"
                >

                    ❯

                </button>


            </div>


            {/* ==================================
                VISOR
            ================================== */}

            {renderViewer()}


        </section>

    );

};


export default EventsComponent;
